import React, { useEffect, useState } from 'react';
import { calculateCarouselData } from '../../../../Helper/DigitalTwin/DigitalTwinFunctions';
import SlickCarouselWithDateHighlight from '../../../../Features/Carousel/SlickCarouselWithDateHighlight';


export default function VitalsChartDateCarousel({
    currentDates,
    onChangeDate,
    primaryGranularity,
    dataGapDates
}) {

    const [arrayOfDates, setArrayOfDatesFormatted] = useState([]);
    const [arrayOfDatesNumeric, setArrayOfDatesNumeric] = useState([]);
    const [carousalStartDate, setCarousalStartDate] = useState({});

    const setCarousalDate = (dateString, params = {}) => {
        setCarousalStartDate({ dateString });
        onChangeDate(dateString);
    };

    const createCarousalDateRanges = () => {
        const { startDate, endDate } = currentDates
        const [carousalDate, tempFormatted, tempNumeric] = calculateCarouselData(startDate, endDate, primaryGranularity)
        setArrayOfDatesFormatted(tempFormatted);
        setArrayOfDatesNumeric(tempNumeric);
        setCarousalDate(carousalDate);
    };

    useEffect(() => {
        createCarousalDateRanges();
    }, [currentDates, primaryGranularity]);

    return (
        <SlickCarouselWithDateHighlight
            Data={arrayOfDates}
            actualDates={arrayOfDatesNumeric}
            setTheDate={setCarousalDate}
            startDate={carousalStartDate?.dateString}
            slidesToShow={primaryGranularity === "raw" ? 5 : 3}
            dataGapDates={dataGapDates}
        />
    )
}
